import { IconsProps } from '@/types/shared'
import React from 'react'

const CheckIcon: React.FC<IconsProps> = (props) => {
    return (
        <div {...props}>
            <svg
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fill="currentColor"
                    d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
                    strokeWidth="1"
                />
            </svg>
        </div>
    )
}

export default CheckIcon
